var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.158203C2.68661 0.158203 0 2.84481 0 6.1582C0 9.4716 2.68661 12.1582 6 12.1582C9.31339 12.1582 12 9.4716 12 6.1582C12 2.84481 9.31339 0.158203 6 0.158203ZM8.21518 8.43767L7.33125 8.43365L6 6.8466L4.67009 8.43231L3.78482 8.43633C3.72589 8.43633 3.67768 8.38945 3.67768 8.32919C3.67768 8.30374 3.68705 8.27963 3.70312 8.25954L5.44554 6.18365L3.70312 4.1091C3.68694 4.08947 3.67796 4.06489 3.67768 4.03945C3.67768 3.98052 3.72589 3.93231 3.78482 3.93231L4.67009 3.93633L6 5.52338L7.32991 3.93767L8.21384 3.93365C8.27277 3.93365 8.32098 3.98052 8.32098 4.04079C8.32098 4.06624 8.31161 4.09035 8.29554 4.11044L6.5558 6.18499L8.29688 8.26088C8.31295 8.28097 8.32232 8.30508 8.32232 8.33052C8.32232 8.38945 8.27411 8.43767 8.21518 8.43767Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.158203)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.1673e3cd3a30b78e4b39fac4791f9238.svg";
export { ForwardRef as ReactComponent };